var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c(
      "div",
      { staticClass: "main-container", attrs: { id: "main-container" } },
      [
        _c("div", { attrs: { id: "after-sales-details" } }, [
          _c("header", [
            _c("div", { staticClass: "status" }, [
              _vm._v(
                _vm._s(
                  _vm.applyInfo.model &&
                    _vm.applyInfo.model.appointmentStatusDesc
                )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "datetime" }, [
              _vm._v(
                _vm._s(_vm.applyInfo.model && _vm.applyInfo.model.updateTime)
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pro" }, [
            _c("div", { staticClass: "pro-img" }, [
              _c("img", { attrs: { src: _vm.productInfo.productImg, alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pro-info" }, [
              _c("div", { staticClass: "pro-title" }, [
                _vm._v(_vm._s(_vm.productInfo.productName))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pro-sku" }, [
                _vm._v(_vm._s(_vm.productInfo.specificationValue))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "apply-info" },
            [_c("InfoShow", { attrs: { formObj: _vm.applyInfo } })],
            1
          ),
          _vm._v(" "),
          _vm.workShow
            ? _c(
                "div",
                { staticClass: "work-order-info" },
                [_c("InfoShow", { attrs: { formObj: _vm.workOrderInfo } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cancel-btn" },
            [
              _vm.btnShow
                ? _c(
                    "van-button",
                    {
                      attrs: {
                        size: "large",
                        type: "primary",
                        round: "",
                        disabled: _vm.btnDisabled
                      },
                      on: { click: _vm.cancelApply }
                    },
                    [_vm._v("取消申请")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }